import Vue from 'vue'
import Router from 'vue-router'

//登录
// import login from '../views/Login';
import home from '../views/Home';
import error from '../error';


//解决router报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

export default new Router({
    linkActiveClass: 'active',
    // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
      // {
      //     path: '/home',
      //     name: 'Home',
      //     component: home,
      //     meta: {
      //         title: "极书"
      //     }
      // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login,
    //   meta: {
    //     title: "极书登录页"
    //   }
    // },
    {
      path: '/404',
      name: 'error',
      component: error
    },
    {
      path:'*',
      component: error
    },
      // 首页
      {
          path: '/home',
          name: 'Home',
          component: () => import('../views/Home.vue'),
          meta: {
              title: "极书"
          },
          title: '首页'
      },
    //   媒体报导
      {
        path: '/report',
        name: 'Report',
        component: () => import('../views/report/report.vue'),
        title: '媒体报导',
        meta: {
            title: '媒体报导'
        },
        children:[

        ]
      },
    //   资讯详情
      {
        path: '/reportInfo',
        name: 'ReportInfo',
        component: () => import('../views/report/reportInfo.vue'),
        meta: {title: '资讯详情'}
    },
      // 产品介绍
      {
          path: '/product',
          name: 'Products',
          component: () => import('../views/Products.vue'),
          meta: {
              title: "极书"
          },
          title: '产品介绍'
      },
      // 解决方案
      {
          path: '/programme',
          name: 'Programme',
          component: () => import('../views/Programme.vue'),
          meta: {
              title: "极书"
          },
          title: '解决方案'
      },
      //   资讯详情
        {
          path: '/caseInfo',
          name: 'CaseInfo',
          component: () => import('../views/caseInfo.vue'),
          meta: {title: '案例详情'}
      },
      // 合作伙伴
      {
          path: '/partner',
          name: 'Partner',
          component: () => import('../views/Partner.vue'),
          meta: {
              title: "极书"
          },
          title: '合作伙伴'
      },
      // 版本
      {
          path: '/edition',
          name: 'Edition',
          component: () => import('../views/Edition.vue'),
          meta: {
              title: "极书"
          },
          title: '版本'
      },
      // {
      //     path: '/login',
      //     name: 'Login',
      //     component: () => import('../views/Login.vue'),
      //     meta: {
      //         title: "极书"
      //     },
      //     title: '版本'
      // },
      {
          path: '/media',
          name: 'Media',
          component: () => import('../views/foot/Media.vue'),
          meta: {
              title: "极书"
          },
          title: '媒体',
          ishide: true
      },
      {
          path: '/mediaDetail',
          name: 'MediaDetail',
          component: () => import('../views/foot/MediaDetail.vue'),
          meta: {
              title: "极书"
          },
          title: '媒体详情',
          ishide: true
      },
      {
          path: '/contact',
          name: 'Contact',
          component: () => import('../views/foot/Contact.vue'),
          meta: {
              title: "极书"
          },
          title: '联系我们'
      },
      {
          path: '/terms',
          name: 'Terms',
          component: () => import('../views/foot/Terms.vue'),
          meta: {
              title: "极书"
          },
          title: '服务条款'
      },
      {
          path: '/help',
          name: 'Help',
          component: () => import('../views/foot/Help.vue'),
          meta: {
              title: "极书"
          },
          title: '帮助中心'
      },
      {
          path: '/video',
          name: 'Video',
          component: () => import('../views/foot/Video.vue'),
          meta: {
              title: "极书"
          },
          title: '帮助中心'
      },
      {
          path: '/class',
          name: 'Class',
          component: () => import('../views/lesson/class/Class.vue'),
          meta: {
              title: "极书"
          },
          title: '班级'
      },
      {
          path: '/addClass',
          name: 'AddClass',
          component: () => import('../views/lesson/class/AddClass.vue'),
          meta: {
              title: "极书"
          },
          title: '添加班级'
      },
      {
          path: '/classStudent',
          name: 'ClassStudent',
          component: () => import('../views/lesson/class/ClassStudent.vue'),
          meta: {
              title: "极书"
          },
          title: '学生列表'
      },
      {
          path: '/endClass',
          name: 'EndClass',
          component: () => import('../views/lesson/class/EndClass.vue'),
          meta: {
              title: "极书"
          },
          title: '添加班级'
      },
      {
          path: '/addHomework',
          name: 'AddHomework',
          component: () => import('../views/lesson/class/AddHomework.vue'),
          meta: {
              title: "极书"
          },
          title: '布置作业'
      },
      {
          path: '/homework',
          name: 'Homework',
          component: () => import('../views/lesson/homework/Homework.vue'),
          meta: {
              title: "极书"
          },
          title: '作业'
      },
      {
          path: '/classHomework',
          name: 'ClassHomework',
          component: () => import('../views/lesson/homework/ClassHomework.vue'),
          meta: {
              title: "极书"
          },
          title: '班级作业'
      },
      {
          path: '/historyHomework',
          name: 'HistoryHomework',
          component: () => import('../views/lesson/homework/HistoryHomework.vue'),
          meta: {
              title: "极书"
          },
          title: '历史作业'
      },
      {
          path: '/correctHomework',
          name: 'CorrectHomework',
          component: () => import('../views/lesson/homework/CorrectHomework.vue'),
          meta: {
              title: "极书"
          },
          title: '批改作业'
      },
      {
          path: '/myPlan',
          name: 'MyPlan',
          component: () => import('../views/lesson/plan/MyPlan.vue'),
          meta: {
              title: "极书"
          },
          title: '我的教材'
      },
      {
          path: '/addPlan',
          name: 'AddPlan',
          component: () => import('../views/lesson/plan/AddPlan.vue'),
          meta: {
              title: "极书"
          },
          title: '创建教材'
      },
      {
          path: '/coursewareList',
          name: 'CoursewareList',
          component: () => import('../views/lesson/plan/CoursewareList.vue'),
          meta: {
              title: "极书"
          },
          title: '课件列表'
      },
      {
          path: '/addCoursewareList',
          name: 'AddCoursewareList',
          component: () => import('../views/lesson/plan/AddCoursewareList.vue'),
          meta: {
              title: "极书"
          },
          title: '添加课件'
      },
      {
          path: '/preparation',
          name: 'Preparation',
          component: () => import('../views/lesson/plan/Preparation.vue'),
          meta: {
              title: "极书"
          },
          title: '课件列表'
      },
      {
          path: '/sharePlan',
          name: 'SharePlan',
          component: () => import('../views/lesson/SharePlan.vue'),
          meta: {
              title: "极书"
          },
          title: '共享教材'
      },
      {
          path: '/courseware',
          name: 'Courseware',
          component: () => import('../views/lesson/courseware/Courseware.vue'),
          meta: {
              title: "极书"
          },
          title: '课件中心'
      },
      {
          path: '/cpreparation',
          name: 'Cpreparation',
          component: () => import('../views/lesson/courseware/Cpreparation.vue'),
          meta: {
              title: "极书"
          },
          title: '课件预览'
      },
      {
          path: '/resource',
          name: 'Resource',
          component: () => import('../views/lesson/resource/Resource.vue'),
          meta: {
              title: "极书"
          },
          title: '资源中心'
      },
      {
          path: '/rpreparation',
          name: 'Rpreparation',
          component: () => import('../views/lesson/resource/Rpreparation.vue'),
          meta: {
              title: "极书"
          },
          title: '资源预览'
      },
      {
          path: '/setting',
          name: 'Setting',
          component: () => import('../views/lesson/Setting.vue'),
          meta: {
              title: "极书"
          },
          title: '个人设置'
      },
      {
          path: '/classView',
          name: 'ClassView',
          component: () => import('../views/lesson/ClassView.vue'),
          meta: {
              title: "极书"
          },
          title: '详情'
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js